import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { HomeServices } from './HomeServices';
import { HomeServicesContent } from './HomeServicesContent';
import { HomeServicesList } from './HomeServicesList';

interface Props {
  index: number;
  data: HomeServices;
  updateData: (body: IElement, index: number) => void;
}

export const HomeServicesFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<HomeServices>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image_preview`}
        altText={`image_preview_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-services body-my-8">
          <HomeServicesContent data={data} update={update} />
          <HomeServicesList data={data} update={update} />
        </div>
      </ElementWrapper>
    </>
  );
};
